<div style="display: block;" class="chart">
  <h3>{{ chartTitle }}</h3>
  @if (loaded) {
  <div>
    @if (!requirementsMet) {
    <div class="error warning banner">
      <h4 class="error-title">
        {{ "taxReturns.error-creating-chart" | transloco }}
      </h4>
      {{ errorMessage }}.
    </div>
    }
  </div>
  } @if (requirementsMet) {
  <div class="error">
    <canvas
      baseChart
      [data]="configuration.data"
      [options]="configuration.options"
      [plugins]="configuration.plugins"
      [type]="configuration.type"
    >
    </canvas>
  </div>
  }
</div>
